import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

export class ParametrosConst {
  /*public static URL_BASE =  "http://10.51.0.172:4200";*/
  public static URL_BASE = '';
  public static TOKEN = 'TOKEN';
  public static TOKEN_CLIENTE = 'TOKEN_CLIENTE';
  public static USUARIO_LOGIN = 'USUARIO';
  public static USUARIO_CLIENTE = 'USUARIO_CLIENTE';
  public static USUARIO_MENU = 'MENU';

  public static CODIGO_ACTION_BUSCAR = 'B';
  public static CODIGO_ACTION_AGREGAR = 'A';
  public static CODIGO_ACTION_ELIMINAR = 'E';
  public static CODIGO_ACTION_EDITAR = 'U';
  public static CODIGO_ACTION_CLONAR = 'C';
  public static DESCRIPCION_ESTADO_INICIAL = 'PENDIENTE';
  public static AGREGAR_ESTADO_INICIAL = 'P';
  public static CLONAR_ESTADO_INICIAL = 'P';

  public static minOpcionesSeleccionadas = 2;
  public static maxOpcionesSeleccionadas = 10;
  public static maxPreguntasPermitidas = 10;
  public static maxOpcionesPermitidas = 10;
  public static maxCaracteresPlantilla = 499;
  public static maxCaracteresPregunta = 100;
  public static MSJ_PREGUNTA_MIN_ELIMINAR = 'La asamblea debe tener al menos una pregunta configurada.';
  public static MSJ_OPCION_MIN_ELIMINAR = '';
  public static MSJ_ELIMINAR = '¿Está seguro que desea eliminar?';
  public static MSJ_ELIMINAR_ASISTENCIA = '¿Está seguro que desea eliminar la asistencia?';
  public static MSJ_ACTIVAR_VOTO = '¿Desea activar la opción de votar del participante?';
  public static MSJ_DESACTIVAR_VOTO = '¿Desea desactivar la opción de votar del participante?';
  public static MSJ_FINALIZAR_VOTO_INCOMPLETO = 'Usted no ha respondido todas las preguntas. ¿Está seguro de finalizar la votación?';
  public static MSJ_FINALIZAR_VOTO_COMPLETO = 'Usted ha respondido todas las preguntas. ¿Desea finalizar la votación?';
  public static MSJ_FINALIZAR_VOTO_NOTA = 'NOTA: Una Vez finalizada la sesión, las respuestas no podrán ser modificadas en cuanto se inicie la votación.';
  // ALERTA
  public static TIEMPO_DURACION_ALERTA_ANIDADO = 2000;
  public static TIEMPO_DURACION_ALERTA = 4000;
  public static TIEMPO_RELOAD = 1500;
  public static HORIZONTAL_POSITION: MatSnackBarHorizontalPosition = 'center';
  public static VERTICAL_POSTION: MatSnackBarVerticalPosition = 'top';
  public static CLASS_CSS_SUCCESS = 'alert-success';
  public static CLASS_CSS_ERROR = 'alert-danger';
  public static CLASS_CSS_INFO = 'alert-info';
  public static CLASS_CSS_WARNING = 'alert-warning';

  // PARAMETROS CONSTANTES
  public static NUMERO_MAXIMO_PREGUNTAS_POR_ASAMBLEA = 'NUMERO_MAXIMO_PREGUNTAS_POR_ASAMBLEA';
  public static NUMERO_MAXIMO_OPCIONES_POR_PREGUNTA = 'NUMERO_MAXIMO_OPCIONES_POR_PREGUNTA';
  public static NUMERO_MAXIMO_IMPORTACIONES_USUARIO = 'NUMERO_MAXIMO_IMPORTACIONES_USUARIO';
  public static TIPO_DE_ENVIO_CORREO_RESULTADOS_DE_VOTACION = 'TIPO_DE_ENVIO_CORREO_RESULTADOS_DE_VOTACION';
  public static CORREOS_ENVIO_RESULTADOS_VOTACION = 'CORREOS_ENVIO_RESULTADOS_VOTACION';
  public static TIPO_DOCUMENTO = 'TIPO_DOCUMENTO';
  public static ESTADOS_USUARIO = 'ESTADOS_USUARIO';
  public static PERFILES_USUARIO = 'PERFILES_USUARIO';
  public static ESTADOS_VOTACION_ASAMBLEA = 'ESTADOS_VOTACION_ASAMBLEA';
  public static TIPO_PARTICIPANTE_ASAMBLEA = 'TIPO_PARTICIPANTE_ASAMBLEA';
  public static LONG_MIN_PWD = 'LONG_MIN_PWD';
  public static TIPO_QUORUM_ASAMBLEA = 'TIPO_QUORUM_ASAMBLEA';
  public static TIPO_ASISTENCIA_ASAMBLEA = 'TIPO_ASISTENCIA_ASAMBLEA';
  public static TIPO_DISCLAIMER_ASAMBLEA = 'DISCLAIMER';

  public static TIPO_ASAMBLEA = 'TIPO_ASAMBLEA';


  // PARAMETRO QR
  public static QR_CONTENT = ParametrosConst.URL_BASE + '/votacion';

  // POLITICA DE CONTRASEÑA
  public static PASS_NUMEROS = '0123456789';
  public static PASS_MAYUSCULAS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  public static PASS_MINUSCULAS = 'abcdefghijklmnopqrstuvwxyz';
  public static PASS_CARACTER_ESPECIAL = 'ñÑ-*._?@!#$%&/=+';

  public static PASS_LONGITUD_MIN = 10;
  public static PASS_REQUIRED_NUMERO = true;
  public static PASS_REQUIRED_MINUSCULA = true;
  public static PASS_REQUIRED_MAYUSCULA = true;
  public static PASS_REQUIRED_CARACTER_ESPECIAL = true;

  public static URL_ROUTER_CAMBIO_CONTRASENIA = '/cambiarContrasenia';
  public static URL_ROUTER_INTRANET_HOME = '/admin';
  public static TIEMPO_ADVERTENCIA_EXPIRACION_CONTRASENIA = 2000;

  public static ESTADO_USUARIO_ACTIVO = '1';
  public static REG_EXP_EMAIL = '^[a-zA-Z0-9._-]+(?:\\.[a-zA-Z0-9._-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$';
  public static HH_MAXIMA = 23;
  public static MM_MAXIMA = 59;
  public static HH_MINIMA = 0;
  public static MM_MINIMA = 0;
  public static MIN_NUM_OPC = 2;
  public static MAX_NUM_OPC = 10;

  public static UNO = 1;
  public static CERO = 0;
  public static ESTADO_CARGA_TXT_INICIAL = 'NO CARGADO';
  public static ESTADO_CARGA_TXT_CARGADO = 'CARGADO';

  public static PREGUNTA_SIMPLE = 1;
  public static PREGUNTA_MULTIPLE = 2;

  public static EDICION_VOTO = 'EDICION_VOTO';
}
